import './ChartMomentum.scss'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useSelector } from 'react-redux'
import { options } from './ChartMomentumConfig'
import useMarket from 'hook/useMarket'
import useHelper from 'hook/useHelper'
import { useState } from 'react'
import LabelFooter from 'components/common/Chart/LabelFooter'
import { getCategoryValueColor } from 'Helpers/helpFunction'

export default function Momentum() {
  const CommnonStore = useSelector((state) => state?.CommnonStore)
  const { filterCashflowStock } = useMarket()
  const MomentumStore = useSelector((state) => state?.MomentumStore)
  const [FilterLabel, setFilterLabel] = useState([])
  const { handleFilterArray } = useHelper();

  const handleChangeFilterLabel = (value) => {
    const FilterLabelNew = handleFilterArray(value, FilterLabel)
    setFilterLabel([...FilterLabelNew])
  }

  return (
    <>
      <div className='wRLrrDkReZ'>
        <HighchartsReact
          highcharts={Highcharts}
          options={options(filterCashflowStock(MomentumStore?.CashflowStockAnalysisMomentum), CommnonStore, FilterLabel)}
        />
        <div className='xiMrXzdYxw'>Hồi phục</div>
        <div className='DMmLDqikXF'>Tăng mạnh</div>
        <div className='yDlUcjzicD'>Giảm mạnh</div>
        <div className='hNpMPRcCbk'>Suy yếu</div>
      </div>
      <LabelFooter selectData={(value) => handleChangeFilterLabel(value)}
        listDefault={FilterLabel} data={[
          { name: MomentumStore?.CashflowStockAnalysisMomentum?.ticker, color: getCategoryValueColor(MomentumStore?.CashflowStockAnalysisMomentum?.categoryStock).color },
          { name: 'Ngành', color: '#FFEA8B' },
        ]} />
    </>
  )
}